import { useSyncExternalStore } from "react";
import { applyTheme, getTheme, subscribeTheme, type ThemeName } from "./theme";

/**
 * React binding for the theme runtime. Returns the active theme and a setter,
 * staying in sync with any other caller of `applyTheme` via the change event.
 */
export function useTheme(): readonly [ThemeName, (t: ThemeName) => void] {
  const theme = useSyncExternalStore(subscribeTheme, getTheme, () => "islands-dark" as ThemeName);
  return [theme, applyTheme];
}
